module.exports = __webpack_public_path__ + "static/media/cursos.a24e0831.png";